const Cancel = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 2H3.5L18.5 22H16L1 2ZM5.5 2H8L23 22H20.5L5.5 2Z" fill="black" />
        <path d="M3 2H8V4H3V2ZM16 22H21V20H16V22Z" fill="black" />
        <path d="M18.5 2H22L5 22H1.5L18.5 2Z" fill="black" />
    </svg>
);
export default Cancel;